export default __webpack_public_path__ + "static/media/watermelonRoseWaterSalad.adbc8b61.jpg";